type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const KitchenIcon = ({ size = 18, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect x="3" y="2" width="18" height="20" rx="2" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <circle cx="12" cy="6" r="1.5" fill={color} stroke="none" />
    <rect x="7" y="13" width="10" height="6" rx="1" />
  </svg>
);
